import { css } from 'styled-components';
import { convertToDarkerRgba } from './convertToDarkerRgba';
export const linkControlledHoverEffect = ({ styledOnlyOnHover, } = {}) => css `
  color: ${({ theme }) => convertToDarkerRgba(theme === null || theme === void 0 ? void 0 : theme.colors.link)};
  font-weight: ${({ theme }) => styledOnlyOnHover ? undefined : theme === null || theme === void 0 ? void 0 : theme.fontWeights[1]};
  text-decoration: underline;
  text-decoration-thickness: 2px;
`;
//# sourceMappingURL=linkControlledHoverEffect.js.map